import tinycolor from "tinycolor2";

export const calculateContrast = (hex1: string, hex2: string): number => {
    const color1 = tinycolor(hex1);
    const color2 = tinycolor(hex2);
    if (!color1.isValid() || !color2.isValid()) return 0;
    const color1luminance = color1.getLuminance();
    const color2luminance = color2.getLuminance();
    return (Math.max(color1luminance, color2luminance) + 0.05) / (Math.min(color1luminance, color2luminance) + 0.05);
};
